import { WORKER_API_BASE } from './api';
import { renderPdfPagesToImages } from './pdfRaster';

const P = '[TeCS-OCR]';
let lastResult: unknown = null;

function authHeaders(): Record<string, string> {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function formatHealthTable(health: any): Array<Record<string, unknown>> {
  const rows: Array<Record<string, unknown>> = [];
  for (const r of [...(health?.parse || []), ...(health?.ocr || [])]) {
    rows.push({ capability: r.capability, provider: r.provider, model: r.model, ok: r.ok, httpStatus: r.httpStatus, latencyMs: r.latencyMs, snippet: r.snippet || r.error || '' });
  }
  return rows;
}

async function health() {
  const res = await fetch(`${WORKER_API_BASE}/llm/health`, { headers: authHeaders() });
  const data = await res.json().catch(() => ({}));
  lastResult = data;
  console.log(`${P} health @ ${data.timestamp}`);
  console.table(formatHealthTable(data));
  return data;
}

async function ocrImage(image: string, prompt?: string) {
  const res = await fetch(`${WORKER_API_BASE}/llm/ocr`, { method: 'POST', headers: { 'Content-Type': 'application/json', ...authHeaders() }, body: JSON.stringify({ image, prompt }) });
  const data = await res.json().catch(() => ({}));
  lastResult = data;
  console.log(`${P} ocrImage`, data);
  return data;
}

async function parse(text: string) {
  const res = await fetch(`${WORKER_API_BASE}/llm/parse`, { method: 'POST', headers: { 'Content-Type': 'application/json', ...authHeaders() }, body: JSON.stringify({ text }) });
  const data = await res.json().catch(() => ({}));
  lastResult = data;
  console.log(`${P} parse`, data);
  return data;
}

async function ocrPdf(file?: File) {
  if (!file) {
    throw new Error('tecsLlm.ocrPdf(file) requires a File — pass the PDF you want to OCR (no bundled PDF asset).');
  }
  const pages = await renderPdfPagesToImages(file);
  console.log(`${P} ocrPdf: rendered ${pages.length} page(s)`);
  const texts: string[] = [];
  for (const page of pages) {
    const r = await ocrImage(page);
    texts.push((r as any)?.text || '');
  }
  const result = { pages: pages.length, text: texts.join('\n\n') };
  lastResult = result;
  console.log(`${P} ocrPdf result`, result);
  return result;
}

export function installTecsLlm(): void {
  (window as any).tecsLlm = { health, ocrImage, ocrPdf, parse, renderPdf: renderPdfPagesToImages, last: () => lastResult };
  console.log(`${P} window.tecsLlm ready — try: tecsLlm.health()`);
}
